import React from 'react';
import PropTypes from 'prop-types';
//Modulos locales
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';



/**
 * 
 * @param {function} onOpenLista
 * @param {Boolean} OpenLista
 * @returns {ReactComponent} Devuelve un Componente que controla un contenido,
 * en caso de hacer hover se muestra el contenido, caso contrario se contrae (funcional para Celulares al hacer click) 
 */
export const ControlListaTutorial = ({onOpenLista, OpenLista, children, ...others}) => {
   const useControlListaTutorialStyles = makeStyles(theme => ({
      general: {
         width: '100%',
         height: '100%',
         display: 'flex',
         position: 'relative',
         zIndex: '100'
      },
      generalAbierto: {
         '&:after': {
            content: '""',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: -1,
            transition: 'background 1s ease-in-out'
         }
      },
      contenido: {
         backgroundColor: 'white',
         border: '1px solid ' + theme.palette.primary.main,
         overflow: 'auto',
         boxSizing: 'border-box',
         padding: '30px',
         whiteSpace: 'nowrap'
      },
      contenidoOpen: {
         boxShadow: 'none',
         transition: 'box-shadow 0.3s ease-out',
         [theme.breakpoints.down('md')]: {
            transition: 'height 0.3s ease-out',
            height: '500px',
            width: '100%'
         },
         [theme.breakpoints.up('md')]: {
            transition: 'width 0.3s ease-out',
            position: 'absolute',
            zIndex: '10',
            width: '600px',
            height: '100%'
         }
      },
      contenidoClose: {
         zIndex: '1',
         boxShadow: 'inset -5px 0px 10px #0a0a0a7F',
         transition: 'width 0.3s ease-in',
         transition: 'box-shadow 0.3s ease-in',
         [theme.breakpoints.down('md')]: {
            height: '250px',
            width: '100%',
            boxShadow: 'none'
         },
         [theme.breakpoints.up('md')]: {
            width: '100%',
            height: '100%'
         }
      },
      button: {
         width: '25%',
         marginBottom: '15px',
         margin: 'auto',
         [theme.breakpoints.down('md')]: {
            display: 'flex'
         },
         [theme.breakpoints.up('md')]: {
            display: 'none'
         }
      }
   }));

   const classes = useControlListaTutorialStyles();

   const handleOpenContenido = () => {
      onOpenLista(true);
   };
   const handleCloseContenido = () => {
      onOpenLista(false);
   };

   return (
      <>
         <div
            className={clsx(classes.general, {
               [classes.generalAbierto]: OpenLista
            })}
         >
            <div
               onMouseEnter={handleOpenContenido}
               onMouseLeave={handleCloseContenido}
               className={clsx(classes.contenido, {
                  [classes.contenidoOpen]: OpenLista,
                  [classes.contenidoClose]: !OpenLista
               })}
            >
               <div onClick={handleOpenContenido}>{children}</div>
            </div>
         </div>
      </>
   );
};

ControlListaTutorial.propTypes = {
   onOpenLista: PropTypes.func,
   OpenLista: PropTypes.bool
};

ControlListaTutorial.defaultProps = {
   onOpenLista: () => {},
   OpenLista: false
};
